export default "__VITE_ASSET__DxYWXL85__"